import { ArrayUtils } from '@colonist/utils';
export class UIGameEventController {
    registerUIGameMechanic(uiGameMechanic) {
        if (ArrayUtils.elementInArray(this.uiGameMechanics, uiGameMechanic)) return;
        this.uiGameMechanics.push(uiGameMechanic);
    }
    isAlreadyRegistered(uiGameMechanic) {
        return ArrayUtils.elementInArray(this.uiGameMechanics, uiGameMechanic);
    }
    unregisterUIGameMechanic(uiGameMechanic) {
        ArrayUtils.removeElementFromArray(this.uiGameMechanics, uiGameMechanic);
    }
    sendEvent(data, notificationType) {
        for (const uiGameMechanic of this.uiGameMechanics){
            uiGameMechanic.onEvent(data, notificationType);
        }
    }
    registerUIGameAnimation(uiGameAnimation) {
        if (ArrayUtils.elementInArray(this.uiGameAnimations, uiGameAnimation)) return;
        this.uiGameAnimations.push(uiGameAnimation);
    }
    unregisterUIGameAnimation(uiGameAnimation) {
        ArrayUtils.removeElementFromArray(this.uiGameAnimations, uiGameAnimation);
    }
    gameTick(deltaTime, elapsedMS) {
        for (const uiGameAnimation of this.uiGameAnimations){
            uiGameAnimation.onGameTick(deltaTime, elapsedMS);
        }
    }
    constructor(){
        this.uiGameMechanics = [];
        this.uiGameAnimations = [];
    }
}
